<span class="text-primary-200 truncate text-{{size}} inline-flex items-center">
    {{timeAgo$ | async}}
</span>